/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Button, Label, Input, Row, Col, FormGroup, InputGroup } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";
import { SelectFormField, CircularProgress } from "../../../../../index";

import { getLocalDate } from "../../../../../utils/dateUtils";
import EventCommission from "./EventCommission";
import RecurringCommission from "./RecurringCommission";
import { Field } from "../../../..";

export const commissionForm = {
  Flat: "Flat",
  Percentage: "Percentage",
};

const CommissionTab = ({ accountId, services }) => {
  const [commission, setCommission] = useState(undefined);
  const [schema, setSchema] = useState(undefined);
  const [schemas, setSchemas] = useState(undefined);
  const [errors, setErrors] = useState({
    recurring: {},
    event: {},
  });
  const [loading, setLoading] = useState(false);

  const handleChangeCommission = (name, value) => {
    const [id, from] = value.split(" - ");
    setCommission((c) => ({
      ...c.commission,
      id,
      from,
      recurring: undefined,
      event: undefined,
    }));
    setSchema(undefined);
    // check to not allow form 2 if only form 1 is allowed
  };

  const handleChange = (name, index, type, value) => {
    const newError = { ...errors };
    const newCommission = { ...commission };
    const typeSchema = schema[type][index];
    const oldType = commission[type][index];
    delete newError[type][index];

    newCommission[type][index][name] = value;

    let compareValue;
    let canCompare = {};
    if (name === "form") {
      compareValue = parseFloat(newCommission[type][index].volume);
      canCompare = {
        min: value.trim() === typeSchema.minForm.trim(),
        max: value.trim() === typeSchema.maxForm.trim(),
      };
    } else if (name === "volume") {
      compareValue = parseFloat(value);
      canCompare = {
        min: oldType.form.trim() === typeSchema.minForm.trim(),
        max: oldType.form.trim() === typeSchema.maxForm.trim(),
      };
    } else if (name === "groupVolume") {
      newCommission.event[index].Group[0].GroupVolume = value;
    }
    // checks that new group volume is in range
    if (name === "groupVolume") {
      const maxCommissionGroup = parseFloat(newCommission.event[index].Group[0].CommissionGroupMax);
      const minCommissionGroup = parseFloat(newCommission.event[index].Group[0].CommissionGroupMin);
      const newIndex = "groupVolume";

      if (value < minCommissionGroup) {
        newError[type][newIndex] = "Value is lower than lower limit";
      } else if (maxCommissionGroup != 0 && value > maxCommissionGroup) {
        newError[type][newIndex] = "Value is higher than upper limit";
      }else{
        // resets the error message
        newError[type][newIndex] = "";
      }
      setErrors(newError);
    }
    // check commission in range
    if (canCompare.min && parseFloat(typeSchema.min) > compareValue) {
      newError[type][index] = "Value is lower than lower limit";
    } else if (canCompare.max && parseFloat(typeSchema.max) < compareValue) {
      newError[type][index] = "Value is higher than upper limit";
    }
    setCommission(newCommission);
    setErrors(newError);
  };

  const setSubassets = (indexRecurring, newSubassets) => {
    const newCommission = { ...commission };
    newCommission.recurring[indexRecurring].subasset = [...newSubassets];
    setCommission(newCommission);
  };

  const handleSave = () => {
    setLoading(true);
    const body = {
      accountId,
      commission: {
        ...commission,
        recurring: commission.recurring.map((rec) => ({
          ...rec,
          subasset: rec.subasset.filter((item) => item.included),
        })),
      },
    };
    services.updateAccountCommission(body, (res) => {
      services.showToast("Commission changed successfully");
      setLoading(false);
    });
  };

  const revert = () => {
    setCommission(undefined);
    setSchema(undefined);
    setErrors({
      recurring: {},
      event: {},
    });
  };

  useEffect(() => {
    services.getCommissionSchemas({}, (res) => {
      setSchemas(
        res.schemas.map((s, index) => ({
          ...s,
          index,
        }))
      );
    });
  }, []);

  useEffect(() => {
    if (!commission) {
      services.getAccountCommission({ accountId }, (res) => {
        setCommission(res.commission);
      });
    }
  }, [commission]);

  useEffect(() => {
    if (!schema && commission) {
      const { id, from } = commission;
      if (id && from) {
        services.getCommissionSchema(
          {
            commissionId: id,
            commissionFrom: from,
          },
          (res) => {
            const { schema: newSchema } = res;
            setErrors({
              recurring: {},
              event: {},
            });
            setSchema(res.schema);
            setCommission((c) => ({
              ...c,
              recurring: c.recurring ? [...c.recurring] : [...newSchema.recurring],
              event: c.event ? [...c.event] : [...newSchema.event],
            }));
          }
        );
      }
    }
  }, [commission, schema]);

  let canSubmit = schemas && schema && commission && commission.recurring && commission.event;
  if (canSubmit) {
    Object.keys(errors.event).forEach((key) => {
      canSubmit = canSubmit && !errors.event[key];
    });
  }
  if (canSubmit) {
    Object.keys(errors.recurring).forEach((key) => {
      canSubmit = canSubmit && !errors.recurring[key];
    });
  }

  return (
    <React.Fragment>
      {schemas && commission ? (
        <SelectFormField
          label="Commission"
          name=""
          selectItems={schemas}
          getSelectItemId={(i) => `${i.id} - ${i.from}`}
          getSelectItemName={(i) => `${i.name} - ${getLocalDate(i.from)}`}
          onChange={handleChangeCommission}
          disabled={!(schema && commission && commission.recurring && commission.event) || loading}
          value={`${commission.id} - ${commission.from}`}
        />
      ) : (
        <CircularProgress sm />
      )}
      {schema && (
        <Row>
          <Col xs={2} lg={2}>
            <Field label={"Account Commission can be Changed:"} />
          </Col>
          <Col xs={1} lg={1}>
            <Input type="checkbox" checked={schema.AccountCommissionsCanBeChanged} disabled={true}></Input>
          </Col>
          <Col xs={2} lg={2}>
            <Field label={"Account use MarkUp:"} />
          </Col>
          <Col xs={1} lg={1}>
            <Input type="checkbox" checked={schema.AccountUseMarkUP} disabled={true}></Input>
          </Col>
        </Row>
      )}
      {schema && commission && commission.recurring && commission.event ? (
        <React.Fragment>
          <RecurringCommission
            loading={loading}
            recurrings={schema.recurring}
            recurring={commission.recurring}
            recurringErrors={errors.recurring}
            handleChange={handleChange}
            setSubassets={setSubassets}
            services={services}
          />
          <EventCommission
            loading={loading}
            events={schema.event}
            event={commission.event}
            eventErrors={errors.event}
            handleChange={handleChange}
          />
        </React.Fragment>
      ) : (
        <CircularProgress sm />
      )}
      <Button style={{ marginRight: 10 }} disabled={loading} onClick={() => revert()}>
        <i className="fa fa-undo" /> Revert
      </Button>
      <LaddaButton
        className="btn btn-ladda btn-primary"
        loading={loading}
        onClick={handleSave}
        disabled={!canSubmit}
        data-style={EXPAND_RIGHT}
      >
        {loading ? "Saving..." : "Change"}
      </LaddaButton>
    </React.Fragment>
  );
};

CommissionTab.propTypes = {
  accountId: PropTypes.string.isRequired,
  // setAccountData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
};

export default CommissionTab;
